import { useEffect, useRef } from "react";

export const useClickOutside = (ref, handleFunction, options) => {
  const enabled = options?.enabled ?? true;

  // Stabilise handler reference so callers don't need useCallback
  const handlerRef = useRef(handleFunction);
  handlerRef.current = handleFunction;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    function handleClickOutside(event) {
      const isComponentStillExists = document.contains(event.target);
      const isComponentInsideRef =
        ref.current && !ref.current.contains(event.target);

      if (isComponentStillExists && isComponentInsideRef) {
        handlerRef.current(event);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, enabled]);
};
